import { css } from "emotion";

export const searchIconWrapper = css({
  marginTop: "var(--s1)"
});
